var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmallArrow = function SvgSmallArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 21.413"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m57.705 0-3.818 1.194a17.702 17.702 0 0 0 5.203 7.644H0v4h59.057a16.883 16.883 0 0 0-4.973 7.425l3.832 1.15c.025-.086 2.68-8.575 12.084-8.575v-4C60.653 8.838 57.818.354 57.705 0Z"
  })));
};
export default SvgSmallArrow;